<template>
    <Header id="nav" style="">
        <div style="display: flex;">
            <router-link to="/" style="" class="mainlink">
                <svg width="36" height="30" viewBox="0 0 36 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34.2653 0.483005C33.9444 0.87401 27.4413 9.69077 25.4698 12.3588H21.1675L29.153 1.53335H24.973L16.9875 12.3588H12.7234C14.6873 9.66011 20.6249 1.53335 20.6249 1.53335H11.3021C10.0641 1.53335 9.06304 1.57935 8.29123 1.67902C7.51942 1.77869 6.87752 2.02402 6.38081 2.41503C5.87646 2.79836 5.47909 3.38104 5.18871 4.15538C4.89832 4.92972 4.62322 5.98773 4.37105 7.32175L3.17894 7.26041V5.32073C3.17894 4.42372 3.15602 3.58037 3.11781 2.78303C3.07196 1.98569 3.01083 1.06568 2.92677 0.00766675C3.79792 0.00766675 33.8909 0 33.8909 0L34.2653 0.483005Z"
                          fill="#AD6766"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M36 22.7549C35.4957 24.2883 35.1059 25.699 34.8385 27.0023C34.5634 28.3056 34.4105 29.3023 34.3647 30H23.6892H22.5888H0.282743L0 29.5247C0.443218 28.988 11.5848 14.1375 11.6918 13.9918H15.1458H22.2679H24.3617C23.9796 14.5132 13.755 28.413 13.7474 28.4206H19.5857H22.5888H23.6892H26.5549C27.4107 28.4206 28.2208 28.3363 28.9849 28.1676C29.7491 27.999 30.4674 27.6923 31.1475 27.2476C31.8276 26.7953 32.4695 26.1896 33.0809 25.4153C33.6846 24.6333 34.2501 23.6519 34.7773 22.4636L36 22.7549ZM18.8444 15.5175L9.32286 28.4206H5.14286L14.6644 15.5175H18.8444Z"
                          fill="#AD6766"/>
                </svg>
                <div style="margin-left: 10px;">
                    <span v-html="getRoute()"></span>&nbsp;&nbsp;&nbsp;
                </div>
            </router-link>
        </div>
        <div class="mainmenu d-flex" style="align-items: center">

            <div class="d-none d-md-flex">

                <router-link to="/ueberuns/marken-kommunikation" :class="{'active':slides}">Über uns</router-link>
                <router-link to="/leistungen">Leistungen</router-link>
                <router-link to="/themen">Themen</router-link>

                <router-link to="/kontakt">Kontakt</router-link>
                &nbsp;
                <a :class="{'active':refs||singleRef}" @click="openRefs">Arbeiten</a>
            </div>
            <div class="openline " style="cursor: pointer;" @click="openSub">
                &nbsp;<svg width="6" height="26" viewBox="0 0 6 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H6V6H0V0Z" fill="#4D4D4D"/>
                <path d="M0 10H6V16H0V10Z" fill="#4D4D4D"/>
                <path d="M0 20H6V26H0V20Z" fill="#4D4D4D"/>
            </svg>
            </div>
        </div>
    </Header>
</template>
<script>
    import store from '@/store'

    export default {
        store,
        name: 'Menu',
        data() {
            return {}
        },
        created: function () {
        },
        props: {
            refs: Boolean,
            sub: Boolean
        },
        methods: {
            getRoute() {
                if (this.$route.meta.singleRef) return "Arbeiten"
                else return "Agentur"
            },
            openRefs() {
                this.$emit('update:refs', true)
            },
            openSub() {
                this.$emit('update:sub', !this.sub)
            }
        },
        watch: {
            '$route.path': function () {
                this.$emit('update:sub', false)            },
        },
        computed: {
            singleRef: function () {
                return this.$route.meta.singleRef
            }, slides: function () {
                return this.$route.meta.slides
            },
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>
    #nav {
        height: 72px;
        padding: 0;
        top: 0;
        display: flex;
        background-color: hsla(0,0%,100%,.95);        position: fixed;
        width: 100%;
        justify-content: space-between;
        /*opacity: 0.85;*/
        z-index: 1000000;
        backdrop-filter: blur(10px);

        /*filter: blur(4px);*/
    }

    .openline {
        align-self: center;
        padding-left: 100px;
        padding-right: 20px;
        margin-bottom: 6px;

        &:hover {
            path {
                fill: $zzcolor;
            }
        }
    }

    .mainlink {
        display: flex;
        align-items: center;
        padding-left: 100px;
        @include mobile {
            padding-left: 20px;
        }
    }

    a {
        font-weight: 500;
        letter-spacing: 0.1em;
        color: $zzgray;
        margin: 20px 10px 10px;
        padding-bottom: 10px;
        line-height: 140%;
        font-size: 16px;
        text-transform: uppercase;
        cursor: pointer;

        &:hover {
            text-decoration: none;
        }
    }

    .mainmenu {
        /*height: calc(100% - 2px);*/
        padding-right: 10px;

        a {
            /*align-self: stretch;*/
            padding: 23px 0;
            border-bottom: 4px solid transparent;
            margin: 0px 20px 0;
            &:hover {
                color: $zzcolor;
            }
        }

        .router-link-exact-active, .active {
            color: $zzcolor;
            border-bottom: 4px solid $zzcolor;
        }
    }
</style>
